"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoalescedFlashcardSchedulingInfo = exports.CoalescedFlashcardSchedulingInfoSchema = exports.isFlashcardInfoForSchedulingSchema = exports.FlashcardInfoForSchedulingSchema = exports.isFlashcardBackForSchedulingSchema = exports.FlashcardBackForSchedulingSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const custom_translation_types_1 = require("../custom_translation_types");
const bootcamp_sentence_types_1 = require("../sentence/bootcamp_sentence_types");
const sentence_word_types_1 = require("../sentence/sentence_word_types");
const dictionary_word_types_1 = require("../word/dictionary_word_types");
const word_entry_types_1 = require("../word/word_entry_types");
const word_types_1 = require("../word/word_types");
const flashcard_back_types_1 = require("./flashcard_back_types");
const flashcard_common_types_1 = require("./flashcard_common_types");
const premade_flashcard_types_1 = require("./premade_flashcard_types");
exports.FlashcardBackForSchedulingSchema = flashcard_back_types_1.BasicFlashcardBackInfoSchema.extend({
    customTranslation: custom_translation_types_1.CustomTranslationSchema.optional(),
    extendedWord: dictionary_word_types_1.ExtendedWordSchema.optional(),
    sentenceWord: sentence_word_types_1.SentenceWordSchema.optional(),
    word: word_types_1.WordSchema.optional(),
    wordEntry: word_entry_types_1.WordEntryWithWordSchema.optional(),
});
exports.isFlashcardBackForSchedulingSchema = type_validation_helpers_1.getTypeValidationFunction(exports.FlashcardBackForSchedulingSchema);
exports.FlashcardInfoForSchedulingSchema = flashcard_common_types_1.BasicFlashcardInfoSchema.extend({
    backs: exports.FlashcardBackForSchedulingSchema.array(),
    bootcampSentence: bootcamp_sentence_types_1.BasicBootcampSentenceSchema.optional(),
    created_at: zod_1.z.string(),
    customTranslation: custom_translation_types_1.CustomTranslationSchema.optional(),
    extendedWord: dictionary_word_types_1.ExtendedWordSchema.optional(),
    premadeFlashcard: premade_flashcard_types_1.AnyPremadeFlashcardDefinitionSchema.optional(),
    sentenceWord: sentence_word_types_1.SentenceWordSchema.optional(),
    word: word_types_1.WordSchema.optional(),
    wordEntry: word_entry_types_1.WordEntryWithWordSchema.optional(),
});
exports.isFlashcardInfoForSchedulingSchema = type_validation_helpers_1.getTypeValidationFunction(exports.FlashcardInfoForSchedulingSchema);
// This is meant to provide a quick look at which items (sentences, words, etc.)
// are present in a flashcard, which is useful for scheduling review sessions
// as we normally want to avoid having flashcards referring to the same word/
// sentence in the same review session.
// In a normal flashcard type, the references to sentences, words and so on can
// either be in the flashcard or the flashcard back, and be split across several
// properties (i.e., a word can be either by itself or inside a word entry).
// "Coalescing" these just means putting all the references in a common place,
// so that it's easier for the scheduler to just look at these common places
// instead of having to iterate through a bunch of props.
exports.CoalescedFlashcardSchedulingInfoSchema = flashcard_common_types_1.BasicFlashcardInfoSchema.extend({
    bootcampSentence: bootcamp_sentence_types_1.BasicBootcampSentenceSchema.optional(),
    created_at: zod_1.z.string(),
    customTranslations: custom_translation_types_1.CustomTranslationSchema.array(),
    extendedWords: dictionary_word_types_1.ExtendedWordSchema.array(),
    premadeFlashcard: premade_flashcard_types_1.AnyPremadeFlashcardDefinitionSchema.optional(),
    rawWords: zod_1.z.string().array(),
    sentenceWords: sentence_word_types_1.SentenceWordSchema.array(),
    wordEntries: word_entry_types_1.WordEntrySchema.array(),
    words: word_types_1.WordSchema.array(),
});
exports.isCoalescedFlashcardSchedulingInfo = type_validation_helpers_1.getTypeValidationFunction(exports.CoalescedFlashcardSchedulingInfoSchema);
//# sourceMappingURL=flashcard_scheduling_types.js.map